import { jsxs, jsx } from 'react/jsx-runtime';
import { isSortField } from '../utils/queryOptionGuards.js';
import { Sort } from '../../filtering/components/Sort.js';
import { useResourceListPreferencesContext } from './ResourceList/contexts/resourceListContextPreferences.js';
import { IconMobileSheet24MiscLetterA, IconMobileSheet24MiscClock, IconMobileSheet24KindMeta } from '@fabric-app/icons/svg';

const sortOptions = [
  {
    label: "Alphabetical",
    value: "name",
    reverseOrder: true,
    defaultOrder: "ASC",
    Icon: IconMobileSheet24MiscLetterA
  },
  {
    label: "Created at",
    value: "createdAt",
    defaultOrder: "DESC",
    Icon: IconMobileSheet24MiscClock
  },
  {
    label: "Modified at",
    value: "modifiedAt",
    defaultOrder: "DESC",
    Icon: IconMobileSheet24MiscClock
  },
  {
    label: "Kind",
    value: "kind",
    defaultOrder: "DESC",
    Icon: IconMobileSheet24KindMeta
  }
];
const FilterSort = ({ disabledSortFields, setSort, sort }) => {
  return /* @__PURE__ */ jsxs(Sort.Root, {
    onChange: ({ field, order }) => {
      setSort(isSortField(field) ? field : "modifiedAt", {
        order
      });
    },
    value: {
      field: sort.property,
      order: sort.direction || "ASC"
    },
    options: sortOptions,
    disabledFields: disabledSortFields,
    children: [
      /* @__PURE__ */ jsx(Sort.Order, {}),
      /* @__PURE__ */ jsx(Sort.Field, {})
    ]
  });
};
const ResourceSort = () => {
  const { disabledSortFields, setSort, sort } = useResourceListPreferencesContext();
  return /* @__PURE__ */ jsx(FilterSort, {
    disabledSortFields,
    setSort,
    sort
  });
};

export { FilterSort, ResourceSort };
//# sourceMappingURL=ResourceSort.js.map
